<template>
  <div>{{cloudprint_error}}</div>
</template>
<script>
  import { mapState } from 'vuex';

  export default {

    data: () => ({
    }),
    created() {
       this.$store.dispatch('Auth/getCloudPrintByLink', this.$route.params.cloudprint_link);
    },
    computed: {
      ...mapState('Auth', [
        'cloudprint_error',
      ]),
    },
  }
</script>
